import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ICity, IRegion} from "../../shared/models/models";
import {ServerService} from "../../shared/services/server.service";
import {EventService} from "../../shared/services/event.service";
import {UserInfo} from '../../components/header/header.component';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-select-city',
  templateUrl: './select-city.component.html',
  styleUrls: ['./select-city.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class SelectCityComponent implements OnInit {

  @Input() region: IRegion | null = null;
  @Input() city: ICity | null = null;

  @Output() selectRegion = new EventEmitter<IRegion>();
  @Output() selectCity = new EventEmitter<ICity>();

  regions: IRegion[] = [];
  cities: ICity[] = [];
  constCities: ICity[] = [];
  user: UserInfo | null = null;
  search: string = '';
  portalId: number | null = null;

  constructor(
    private serverService: ServerService,
    private eventService: EventService
  ) {
  }

  ngOnInit() {
    this.loadUser();
    this.loadRegions();
  }

  private loadUser() {
    const user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
      this.portalId = this.user.roles.includes("MioUser") && !this.user.roles.includes("BDAdmin") ? 1 : null;
    }
  }

  private loadRegions() {
    this.serverService.getRegions().then(regions => {
      this.regions = regions;
      this.initializeRegion();
    });
  }

  private initializeRegion() {
    if (!this.region) return;

    const activeRegion = this.regions.find(r => r.id === this.region?.id) || this.regions[0];
    this.setRegion(activeRegion);
  }

  regionClasses(region: IRegion): string {
    const classes = ['region'];
    if (region.active) classes.push('active');
    if ([1, 2].includes(region.id)) classes.push('white');
    return classes.join(' ');
  }

  setRegion(region: IRegion) {
    this.regions.forEach(r => r.active = false);
    region.active = true;
    this.selectRegion.emit(region);

    this.serverService.getCities(region.id).then(cities => {
      this.cities = cities;
      this.constCities = cities;
      this.initializeCity();
    });
    this.eventService.disableBodyScrollbar.emit(true);
  }

  private initializeCity() {
    if (!this.city) return;

    const activeCity = this.cities.find(c => c.id === this.city?.id);
    if (activeCity) {
      activeCity.active = true;
    }
  }

  setCity(city: ICity) {
    this.cities.forEach(c => c.active = false);
    city.active = true;
    this.selectCity.emit(city);
    this.eventService.disableBodyScrollbar.emit(true);
  }

  filterCities() {
    const searchQuery = this.search.trim().toLowerCase();
    this.cities = searchQuery
      ? this.constCities.filter(city => city.name.toLowerCase().includes(searchQuery))
      : this.constCities;
  }
}
